export default "__VITE_ASSET__CK$j1DfR__"